// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"312":"f9fae98530f10c37","600":"ec7fb4acf45892fd"}[chunkId] + ".js";
};